import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "src/config/axios";
import { Button, Col, Row, Form as BTForm } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import { Formik, Form } from "formik";
import history from "src/global/history";
import { showErrorToast, showSuccessToast } from "src/components/Toasts/";
import AdminDashboard from "../../index";
import FormInputText from "../../../../components/Forms/FormInputText";
import FormSelectBox from "../../../../components/Forms/FormSelectBox";
import UsersSidebar from "../Users/Edit/_users-sidebar";
import moment from "moment";
import MultiLanguageInputText from "../../../../components/Forms/MultiLanguageInputText";
import FormFileUpload from "src/components/FileUpload";

const EditBusiness = () => {
  const { id } = useParams();

  const [business, setBusiness] = useState();
  const pricing_models = [
    { name: "Camping", id: "camping" },
    { name: "Parking", id: "parking" },
  ];

  const getBusiness = () => {
    axios
      .get(`/api/v1/admin/businesses/${id}.json`)
      .then(function (response) {
        setBusiness(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (id != null) {
      getBusiness();
    }
  }, []);

  const fillForm = () => {
    const form = {};

    form.name = business?.name ?? "";
    form.expire_at = business?.expire_at ?? "";
    form.subdomain = business?.subdomain ?? "";
    form.contact_person = business?.contact_person ?? "";
    form.contact_nr = business?.contact_nr ?? "";
    form.pricing_model = business?.pricing_model ?? "";
    form.email = business?.email ?? "";
    form.printer_logo_width = business?.printer_logo_width ?? "";
    form.printer_logo = business?.printer_logo ?? "";
    form.camp_site_map = business?.camp_site_map ?? "";
    form.logo = business?.logo ?? "";
    form.address = business?.address ?? "";
    form.address_it = business?.address_it ?? "";
    form.address_en = business?.address_en ?? "";
    form.location = business?.location ?? "";
    form.location_it = business?.location_it ?? "";
    form.location_en = business?.location_en ?? "";

    return form;
  };

  const submit = (values) => {
    let request;

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    var formData = new FormData();
    formData.append("business[name]", values.name);
    formData.append("business[subdomain]", values.subdomain);
    formData.append(
      "business[expire_at]",
      moment(values.expire_at).format(moment.HTML5_FMT.DATE)
    );
    formData.append("business[contact_person]", values.contact_person);
    formData.append("business[contact_nr]", values.contact_nr);
    formData.append("business[email]", values.email);
    formData.append("business[pricing_model]", values.pricing_model);
    formData.append("business[printer_logo_width]", values.printer_logo_width);
    formData.append("business[address]", values.address);
    formData.append("business[address_it]", values.address_it);
    formData.append("business[address_en]", values.address_en);
    formData.append("business[location]", values.location);
    formData.append("business[location_it]", values.location_it);
    formData.append("business[location_en]", values.location_en);
    formData.append("business[remove_logo]", values.remove_logo ?? false);
    formData.append(
      "business[remove_camp_site_map]",
      values.remove_camp_site_map ?? false
    );
    formData.append(
      "business[remove_printer_logo]",
      values.remove_printer_logo ?? false
    );

    if (values.logo && values.logo instanceof File) {
      formData.append("business[logo]", values.logo);
    }

    if (values.printer_logo && values.printer_logo instanceof File) {
      formData.append("business[printer_logo]", values.printer_logo);
    }

    if (values.camp_site_map && values.camp_site_map instanceof File) {
      formData.append("business[camp_site_map]", values.camp_site_map);
    }

    if (id) {
      request = axios.put(
        `/api/v1/admin/businesses/${id}.json`,
        formData,
        config
      );
    } else {
      request = axios.post(`/api/v1/admin/businesses/`, formData, config);
    }

    request
      .then(function () {
        history.push(`/dashboard`);
        showSuccessToast();
      })
      .catch(function (error) {
        showErrorToast(error.response.data);
      });
  };

  return (
    <AdminDashboard>
      <>
        <Row>
          <Col>
            <Button
              className="mb-3 mr-2"
              variant="outline-primary"
              onClick={() => history.push("/dashboard")}
            >
              Zurück
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={7}>
            <Card title={business?.name ?? "Neu"}>
              <div className="table-responsive">
                <Formik
                  initialValues={fillForm()}
                  enableReinitialize={true}
                  validate={(values) => {
                    const errors = {};

                    return errors;
                  }}
                  onSubmit={(data, { setSubmitting }) => {
                    setSubmitting(true);
                    submit(data);
                    setSubmitting(false);
                  }}
                >
                  {({ values, isSubmitting, setFieldValue }) => (
                    <Form autoComplete="false">
                      <FormInputText label="Name" name="name" required />
                      <FormInputText
                        label="Subdomain"
                        name="subdomain"
                        required
                      />
                      <FormInputText
                        type="date"
                        label="Ablaufdatum"
                        name="expire_at"
                        required
                      />
                      <FormInputText
                        label="Kontaktperson"
                        name="contact_person"
                        required
                      />
                      <FormInputText
                        label="Kontaktnummer"
                        name="contact_nr"
                        required
                      />
                      <FormInputText label="E-Mail" name="email" required />
                      <FormInputText
                        label="Printer Logo Breite"
                        name="printer_logo_width"
                      />
                      <FormSelectBox
                        label="Modell"
                        name="pricing_model"
                        options={pricing_models}
                        option_value="id"
                        option_name="name"
                        required
                      />
                      <FormFileUpload label="Logo" name="logo" />
                      <FormFileUpload label="Lageplan" name="camp_site_map" />
                      <FormFileUpload
                        label="Logo für Drucker"
                        name="printer_logo"
                      />

                      <h2>Anschrift</h2>
                      <MultiLanguageInputText
                        label="Adresse"
                        name="address"
                        languages={["de", "it", "en"]}
                      />
                      <MultiLanguageInputText
                        label="PLZ und Ort"
                        name="location"
                        languages={["de", "it", "en"]}
                      />

                      <Button
                        disabled={isSubmitting}
                        variant="primary"
                        type="submit"
                      >
                        Abschicken
                      </Button>
                    </Form>
                  )}
                </Formik>
              </div>
            </Card>
          </Col>
          <Col>
            <UsersSidebar business_id={id} />
          </Col>
        </Row>
      </>
    </AdminDashboard>
  );
};

export default EditBusiness;
